<template>
    <section :class="lvl === 0 ? 'box' : 'box-children'">
        <section :class="[point.is_active ? 'box__active' : 'box__top', (!point.is_active && point.is_done) ? 'box__done' : '']" :id="'id-point-' + point.id">
            <section>
                <PointInformationPublicModal :point="point" :lvl="lvl" :numerations="numerations" />
                <VotingListPublicModal v-if="point.votings?.length" :votings="point.votings" />

                <AgendaItemPublicModal v-for="child in point.children"
                            :key="child.id"
                            :point="child"
                            :lvl="lvl + 1"
                            :numerations="numerations" />
            </section>
        </section>
    </section>
</template>

<script charset="utf-8">
import PointInformationPublicModal from './PointInformationPublicModal.vue'
import VotingListPublicModal from './VotingListPublicModal.vue'
import AgendaItemPublicModal from './AgendaItemPublicModal.vue' // self-reference (rekurencja)

export default {
    name: "AgendaItemPublicModal",
    data() {
        return {

        };
    },
    props: {
        point: Object,
        lvl: Number,
        numerations: Object
    },
    components: {
        PointInformationPublicModal,
        VotingListPublicModal,
        AgendaItemPublicModal
    },
    methods: {

    }
};
</script>

<style lang="scss" scoped>
    .box {
        background: #ffffff;
        width: 100%;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        box-shadow: 6px 6px 24px rgba(0, 8, 44, 0.03);
        border-radius: 12px;
        margin-bottom: 12px;
        transition: all 0.2s ease-in-out;

        &__title {
            font-size: 1.7em;
            font-weight: 500;
            margin-right: 16px;
            //font-size: 16px;
            line-height: 132%;
            color: #00082c;
            overflow-wrap: break-word;
            word-break: break-word;
        }

        &__top {
            //display: flex;
            align-items: center;
            padding: 12px;
            justify-content: space-between;
            font-size: 16px;
        }

        &__active {
            align-items: center;
            padding: 29px;
            justify-content: space-between;
            border: 1px solid green;
            background: #f7fff7;
            border-radius: 12px;
            font-size: 24px;
        }

        &__done {
            background: #ffffff;
            align-items: center;
            padding: 12px;
            justify-content: space-between;
            border-radius: 12px;
            font-size: 16px;
        }

        &--takenoff {
            text-decoration: line-through !important;
        }
    }

    .box-children {
        background: #ffffff;
        border: 1px solid #dce4ee;
        box-sizing: border-box;
        box-shadow: 6px 6px 24px rgba(0, 8, 44, 0.03);
        border-radius: 12px;
        margin: 12px 12px 0px 32px;
        transition: all 0.2s ease-in-out;
    }
</style>
